import React, { forwardRef } from 'react';
import { StyledButton } from './BlockedModalButton.styles';
const BLOCKED_LINK_WRAPPER_TEST_IDS = {
    wrapper: 'blocked-link-wrapper-test-id',
};
export const BlockedModalButton = forwardRef(({ children, isBlocked, ...rest }, ref) => {
    if (!isBlocked) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement(StyledButton, { ref: ref, "data-testid": BLOCKED_LINK_WRAPPER_TEST_IDS.wrapper, type: "button", "aria-label": "Open modal", ...rest }, children));
});
